export enum NAV_DATA_TYPE {
  CLASS_OF = 'CLASS_OF',
  POINT_PERSON = 'POINT_PERSON',
  GRADE = 'GRADE',
  TEACHER = 'TEACHER',
  GRAD_PLAN = 'GRAD_PLAN',
  SUBJECT = 'SUBJECT',
  COURSE = 'COURSE',
  COLLEGE_PLAN = 'COLLEGE_PLAN',
}
